export enum EditingRights {
  ReadOnly = 'ReadOnly', Limited = 'Limited', Full = 'Full'
}
